import { ValidateCprFunction } from '../types'
import i18n from 'i18next'

const validateCPR: ValidateCprFunction = async (
	cprNumber: string | undefined,
) => {
	if (cprNumber == null || cprNumber.length < 5) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}
	return {
		success: true,
		output: cprNumber,
	}
}

export default validateCPR
